<app-header titleName="{{'FUEL-PLACES--PLACES' | translate}}"></app-header>

<ion-content class="ion-padding" [style.--background]="customerColor">
  <small class="list-description">
    {{"FUEL-PLACES--SELECT" | translate}}:
  </small>

  <ion-searchbar
    placeholder="{{'FUEL-PLACES--SEARCH' | translate}} ..."
    (input)="searchAdddress($event)"
    animated="true"
  ></ion-searchbar>

  @if (filteredAddressesList.length === 0 && isAddressesLoaded) {
    <small
      class="no-address-found"
      >
      {{"FUEL-PLACES--NOT-FOUND" | translate}}
    </small>
  }

  @if (filteredAddressesList.length !== 0) {
    <ion-list>
      @for (address of filteredAddressesList; track address) {
        <ion-item
          button
          (click)="selectAddress(address)"
          mode="md"
          >
          <ion-label>{{ address.local }}</ion-label>
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-item>
      }
    </ion-list>
  }
</ion-content>
